import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { DataTableParams } from 'angular-datatables-all-versions';

import { AssociationService } from '../../../shared/services/association.service';
import { IPaginationAssocs, IAssoc } from './ipagination-assocs.model';
import { NgDataTableSortFormatterUtility } from '../../../shared/common/tools/ngdatatablesort-formatter.utility';

export class AssociationsListDataSource implements DataSource<IAssoc> {

  private assocsSubject = new BehaviorSubject<IAssoc[]>([]);
  private paginationSubject = new BehaviorSubject<IPaginationAssocs>({} as IPaginationAssocs);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private ngDataTableSortFormatterUtility = new NgDataTableSortFormatterUtility();

  public pagination = this.paginationSubject.asObservable().pipe(distinctUntilChanged());
  public loading$ = this.loadingSubject.asObservable();

  constructor(private service: AssociationService) { }

  connect(_collectionViewer: CollectionViewer): Observable<IAssoc[]> {
    return this.assocsSubject.asObservable();
  }

  disconnect(_collectionViewer: CollectionViewer): void {
    this.assocsSubject.complete();
    this.loadingSubject.complete();
    this.paginationSubject.complete();
  }

  load(search = '', offset = 1, limit = 5, category = 'all', sort = null) {
    this.loadingSubject.next(true);
    this.service.find({ offset, limit, search, category } as DataTableParams).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    ).subscribe((data: IPaginationAssocs) => {
      if (data && data.assocs) {
        this.assocsSubject.next(data.assocs);
      } else {
        this.assocsSubject.next([]);
      }

      if (sort) {
        let list = data.assocs;

        list = list.sort((item1, item2) => {
          const sortAsc = sort['sortAsc'];
          let fieldToSort = sort['sortBy'];
          let firstVal;
          let secondVal;

          if (sort['sortBy'] === 'category_name') {
            fieldToSort = 'category.name';
          }

          firstVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item1);
          secondVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item2);

          firstVal = firstVal ? typeof firstVal === 'string' ? firstVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : firstVal : '';
          secondVal = secondVal ? typeof secondVal === 'string' ? secondVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : secondVal : '';

          return sortAsc ?
            firstVal < secondVal ? -1 : firstVal > secondVal ? 1 : 0
            :
            firstVal < secondVal ? 1 : firstVal > secondVal ? -1 : 0;
        });

        data.assocs = list;
      }

      this.paginationSubject.next(data);
    });
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
